import { Outlet, useLocation } from 'react-router-dom'
import { motion, AnimatePresence } from 'framer-motion'
import { Sidebar } from './Sidebar'
import { Header } from './Header'
import { useUIStore } from '@stores/ui'

// Page transition variants
const pageVariants = {
  initial: {
    opacity: 0,
    y: 8,
  },
  enter: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.3,
      ease: 'easeOut' as const,
    },
  },
  exit: {
    opacity: 0,
    y: -8,
    transition: {
      duration: 0.2,
      ease: 'easeIn' as const,
    },
  },
}

export function AppLayout() {
  const sidebarCollapsed = useUIStore((state) => state.sidebarCollapsed)
  const location = useLocation()

  return (
    <div className="flex h-screen bg-mesh">
      {/* Sidebar */}
      <Sidebar />

      {/* Main content area */}
      <motion.div
        initial={false}
        animate={{
          marginLeft: sidebarCollapsed ? 80 : 280,
        }}
        transition={{ duration: 0.3, ease: 'easeOut' }}
        className="flex flex-1 flex-col min-w-0 relative z-10"
      >
        {/* Header */}
        <Header />

        {/* Main content with page transitions */}
        <main className="flex-1 overflow-y-auto">
          <AnimatePresence mode="wait">
            <motion.div
              key={location.pathname}
              variants={pageVariants}
              initial="initial"
              animate="enter"
              exit="exit"
              className="p-6 lg:p-8"
            >
              <Outlet />
            </motion.div>
          </AnimatePresence>
        </main>

        {/* Footer */}
        <footer className="flex items-center justify-between px-6 py-3 border-t border-slate-700/50 glass">
          <p className="text-xs text-slate-600">
            VelesMassApp Enterprise v2.0
          </p>
          <p className="text-xs text-slate-600">
            Powered by Veles Digital
          </p>
        </footer>
      </motion.div>
    </div>
  )
}
